export default __webpack_public_path__ + "static/media/esperando.308291d5.png";